<template>
  <el-container class="payroll_list">
    <el-main>
      <div style="display: flex;justify-content: flex-start;">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="calculatePayroll">执行结算</el-button>
      </div>
      <div style="display: flex;justify-content: center;display:inline;">
        <el-date-picker v-model="workMonth" format="yyyy-MM" value-format="yyyy-MM" type="month"  placeholder="选择月" size="small"></el-date-picker>
        <el-select v-model="deptId" size="small" placeholder="选择机构" style="width:200px">
          <el-option label="全部" :key="0" :value="0"/>
            <el-option
              v-for="item in depts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
        </el-select>
        <el-select v-model="userId" size="small" filterable placeholder="选择用户" style="width:100px">
          <el-option label="全部" :key="0" :value="0"/>
            <el-option
              v-for="item in users"
              :key="item.id"
              :label="item.loginName"
              :value="item.id"
            ></el-option>
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          style="margin-left: 3px"
          @click="searchClick"
        >搜索</el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="payrolls"
        tooltip-effect="dark"
        style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
        max-height="560"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="loginName" label="用户名" width="100" align="center"></el-table-column>
        <el-table-column prop="workMonth" label="月份" width="100" align="center" ></el-table-column>
        <el-table-column prop="deptName" label="所属部门" width="100" align="center"></el-table-column>
        <el-table-column prop="requiredAttendanceDays" label="应出勤" width="100" align="center" ></el-table-column>
        <el-table-column prop="attendanceDays" label="实际出勤" width="100" align="center" ></el-table-column>
        <el-table-column prop="otherCost" label="其他扣除" width="100" align="center" ></el-table-column>
        <el-table-column prop="workloadTotal" label="工作总量" width="100" align="center" ></el-table-column>
        <el-table-column prop="unitPrice" label="执行单价" width="100" align="center"></el-table-column>
        <el-table-column prop="workloadSalary" label="工作量工资" width="100" align="center"></el-table-column>
        <el-table-column prop="travelSubsidy" label="出差补助" width="100" align="center"></el-table-column>
        <el-table-column prop="absence" label="请假（小时）" width="150" align="center"></el-table-column>
        <el-table-column prop="absenceCost" label="请假扣除额" width="100" align="center"></el-table-column>
        <el-table-column prop="noAbsentCost" label="全勤奖" width="100" align="center"></el-table-column>
        <el-table-column prop="insuranceSubsidy" label="保险补贴" width="100" align="center"></el-table-column>
        <el-table-column prop="insuranceCost" label="社保扣除" width="100" align="center"></el-table-column>
        <el-table-column prop="dormitoryCost" label="宿舍费" width="100" align="center"></el-table-column>
        <el-table-column prop="payable" label="工资总额" width="100" align="center"></el-table-column>
        <el-table-column prop="tax" label="个人所得税" width="100" align="center"></el-table-column>
        <el-table-column
          prop="payable"
          label="实发工资"
          width="150"
          >
          <template slot-scope="scope">
            <el-tag effect="dark"
              :type="scope.row.netPay >=3500 ? 'success' : 'danger'"
              disable-transitions>{{scope.row.netPay}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag effect="dark"
              :type="scope.row.status ==0 ? 'danger' : 'success'"
              disable-transitions>{{statusName(scope.row.status)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" v-if="showEdit || showDelete" width="300">
          <template slot-scope="scope">
            <el-button size="mini" @click="editPayroll(scope.$index, scope.row)" v-if="showEdit">重新计算</el-button>
            <el-button size="mini" @click="editPayroll(scope.$index, scope.row)" v-if="showEdit">编辑</el-button>
            <el-popconfirm
              placement="top"
              width="260"
              icon="el-icon-info"
              iconColor="red"
              title="确定要删除吗？"
              @onConfirm="delPayroll(scope.row.id)">
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="del_confirm_visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="del_confirm_visible = false">确定</el-button>
              </div>
              <el-button size="mini" type="danger" v-if="showDelete" slot="reference" @click="del_confirm_visible=true">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="guest_table_footer">
        <el-pagination
          background
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="currentChange"
          v-show="payrolls.length>0"
        ></el-pagination>
      </div>
    </el-main>
    <el-dialog height="600" :title="dlg_title" :visible.sync="dialogVisible" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="90px" label-position="left" label-suffix="" :model="formData" ref="formData">
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <el-form-item label="选择机构">
              <el-select v-model="formData.deptId" size="small" placeholder="选择机构">
                  <el-option
                    v-for="item in depts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择项目">
              <el-select v-model="formData.projectId" size="small" placeholder="选择项目">
                  <el-option
                    v-for="item in projects"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择用户">
              <el-select v-model="formData.userId" size="small" placeholder="选择用户">
                  <el-option
                    v-for="item in users"
                    :key="item.id"
                    :label="item.loginName"
                    :value="item.id"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="工作日期">
              <el-date-picker
                v-model="formData.workDate"
                type="date"
                :clearable="false"
                value-format="yyyy-MM-dd"
                placeholder="工作日期"
                @blur="
                  blurInput(scope.row.id, 'planStartTime', scope.row.planStartTime)
                "
                v-focus
                size="mini"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="选择任务">
              <el-select v-model="formData.task" size="small" placeholder="选择任务">
                  <el-option
                    v-for="item in tasks"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          </el-row>
          <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="执行工作量">
              <el-input
                maxlength="50"
                v-model="formData.executiveQuota"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          </el-row>
          <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="工作量">
              <el-input
                v-model="formData.quantity"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          </el-row>
          <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select v-model="formData.auditStatus" size="small" placeholder="状态">
                  <el-option
                    v-for="item in auditStatuses"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="savePayroll">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog height="600" :title="dlg_title" :visible.sync="dialogVisible2" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="90px" label-position="left" label-suffix="" :model="formData" ref="formData">
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <el-form-item label="结算月份">
              <el-date-picker
                v-model="workMonth"
                type="month"
                :clearable="false"
                value-format="yyyy-MM"
                placeholder="结算月份"
                @blur="blurInput(scope.row.id, 'planStartTime', scope.row.planStartTime)"
                v-focus
                size="mini"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="doCalculatePayroll">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import { getRequest, postRequest, putRequest } from '../../utils/api'
import { HttpStatus } from '../../utils/httpstatus'
import '../../utils/filter_utils'
import {clearObject} from '../../utils/utils'

export default {
  mounted: function () {
    this.loading = true
    this.loadUsers()
    this.loadDepts()
    this.loadPayrolls()
  },
  data () {
    return {
      projects: [],
      depts: [],
      users: [],
      task: '',
      tasks: [{name: '编页'}, {name: '扫描'}, {name: '图处'}, {name: '质检'}, {name: '著录'}, {name: '校对'}, {name: '装订'}, {name: '工时'}],
      projectId: '',
      deptId: '',
      userId: '',
      payrolls: [],
      loading: false,
      pageSize: 200,
      totalCount: 0,
      currentPage: 1,
      selItems: [],
      keyword: '',
      showEdit: true,
      showDelete: true,
      del_confirm_visible: false,
      sel_del_confirm_visible: false,
      members: [],
      memberIds: '',
      formData: {},
      dlg_title: '请假',
      dialogVisible: false,
      dialogVisible2: false,
      auditStatus: '0',
      auditStatuses: [{name: '待审核', value: 0}, {name: '审核通过', value: 1}],
      workMonth: ''
    }
  },
  methods: {
    loadUsers () {
      let _this = this
      getRequest('/user/list').then(
        resp => {
          this.users = resp.data.data.users
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadDepts () {
      let _this = this
      getRequest('/dept').then(
        resp => {
          this.depts = resp.data
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadPayrolls () {
      const _this = this
      var url = '/payroll/list/' + _this.currentPage + '/' + _this.pageSize + "?t=0"
      if (this.workMonth !== '') {
        url = url + '&workMonth=' + encodeURIComponent(this.workMonth)
      }
      if (this.deptId !== '') {
        url = url + '&deptId=' + encodeURIComponent(this.deptId)
      }
      if (this.userId !== '') {
        url = url + '&userId=' + encodeURIComponent(this.userId)
      }
      getRequest(url).then(
        resp => {
          _this.payrolls = resp.data.data.payrolls
          _this.totalCount = resp.data.data.totalCount
          _this.loading = false
        },
        resp => {
          _this.$alert('网络连接错误')
          _this.loading = false
        }
      )
    },
    calculatePayroll () {
      this.dialogVisible2 = true
    },
    doCalculatePayroll () {
      const _this = this
      getRequest('/payroll/calculate/' + _this.workMonth).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.$alert(resp.data.msg)
          _this.dialogVisible2 = false
          this.loadPayrolls()
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    addPayroll () {
      this.dialogVisible = true
      this.formData = {}
      this.dlg_title = '添加'
    },
    editPayroll (index, row) {
      this.dialogVisible = true
      this.payrollId = row.id
      this.loadPayroll()
      this.dlg_title = '编辑'
    },
    loadPayroll () {
      let _this = this
      getRequest('/payroll/index/' + this.payrollId).then(
        resp => {
          this.formData = resp.data
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    savePayroll () {
      const _this = this
      clearObject(this.formData)
      postRequest('/payroll/add', this.formData).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.$alert(resp.data.msg)
          _this.dialogVisible = false
          this.loadPayrolls()
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    delPayroll (id) {
      let _this = this
      putRequest('/payroll/del/' + id).then(
        resp => {
          _this.$message.success('删除成功')
          this.loadPayrolls()
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    currentChange (currentPage) {
      this.currentPage = currentPage
      this.loading = true
      this.loadPayrolls()
    },
    handleSelectionChange (val) {
      this.selItems = val
    },
    searchClick () {
      this.loadPayrolls()
    },
    itemClick (row) {
      this.handleEdit(0, row)
      // this.$router.push({ path: '/blogDetail', query: { aid: row.id } })
    },
    statusName (ststus) {
      return ststus === 0 ? '待审核' : '审核通过'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/Views/Payroll/PayrollMana.vue